export const userReducer = (state = null, action) => {
  switch (action.type) {
    case "GET_USER":
      return action.user;
    default:
      return state;
  }
};

export const loadingReducer = (state = false, action) => {
  switch (action.type) {
    case "LOADING":
      return action.loading;
    default:
      return state;
  }
};

export const vacanciesReducer = (state = [], action) => {
  switch (action.type) {
    case "GET_VACANCIES":
      return action.vacancies;
    default:
      return state;
  }
};

export const showNotificationReducer = (state = true, action) => {
  switch (action.type) {
    case "SHOW_NOTIFICATION":
      return action.state;
    default:
      return state;
  }
};

export const selectApplicantsReducer = (state = null, action) => {
  switch (action.type) {
    case "SELECTED_APPLICANTS":
      return action.applicants;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducer.js